<template>
  <div
    :class="selected ? 'chip chip-selected' : 'chip'"
    v-text="text"
    @click="$emit('click', value)"
  ></div>
</template>

<script>
export default {
  props: {
    text: { type: String, require: true, },
    value: { type: String, require: true, },
    selected: { type: Boolean, require: false, default: false },
  },
}
</script>

<style lang="stylus" scoped>
div.chip
  display inline-block
  color #000000
  height 38px
  line-height 38px
  border 1px solid #C5C3C3
  box-sizing border-box
  border-radius 32px
  background #FFFFFF
  font-size 14px
  text-align center
  letter-spacing -0.0241176em
  padding 0 16px
  margin 4px
  cursor pointer
div.chip-selected
  color #FF5500
  border 1px solid #FFAA80
</style>
